import { useMemo } from "react";
import { toAbsoluteUrl } from "../../../_metronic/helpers";
import { getPartnerForCurrentHostname } from "./partnerConfig";

type PartnerAssociationBlockProps = {
  className: string;
  label?: string;
};

export function PartnerAssociationBlock({
  className,
  label = "In association with",
}: PartnerAssociationBlockProps) {
  const partner = useMemo(getPartnerForCurrentHostname, []);

  if (!partner) return null;

  return (
    <div className={className}>
      <span>{label}</span>
      <img src={toAbsoluteUrl(partner.src)} alt={partner.alt} />
    </div>
  );
}
